import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "../Reveal";
import { useSite } from "../../context/SiteContext";
import { mediaUrl } from "../../lib/api";

export const ServicesPreview = () => {
  const { settings } = useSite();
  const services = Array.isArray(settings?.services) ? settings.services : [];
  if (!services.length) return null;
  return (
    <section data-testid="services-preview-section" className="bg-sand">
      <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <SectionHeading eyebrow="What We Create" title={<>Creative Content, <span className="italic">Beautifully Crafted.</span></>} />
          <Reveal>
            <Link to="/services" className="btn btn-secondary" data-testid="home-explore-services-btn">Explore Services</Link>
          </Reveal>
        </div>
        <div className="mt-20 grid gap-14 md:grid-cols-3 md:gap-8">
          {services.map((s, i) => (
            <Reveal key={s.key || i} delay={i * 0.12} className={i === 1 ? "md:mt-20" : ""}>
              <div className="group" data-testid={`home-service-${i}`}>
                <div className="frame relative aspect-[3/4] overflow-hidden">
                  <img src={mediaUrl(s.image)} alt={s.home_title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.04]" />
                </div>
                <p className="mt-6 font-serif text-lg italic text-wine/70">0{i + 1}</p>
                <h3 className="mt-1 font-serif text-3xl text-wine">{s.home_title}</h3>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-charcoal/80 md:text-base">{s.home_description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
